import React from 'react';
import type { PaginationProps } from 'antd';
import { DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons';

type PagerItemRender = NonNullable<PaginationProps['itemRender']>;

interface EdgeButtonProps {
    disabled: boolean;
    onClick: () => void;
    children: React.ReactNode;
}

const EdgeButton: React.FC<EdgeButtonProps> = ({
    disabled,
    onClick,
    children,
}) => (
    <button
        type="button"
        className="ant-pagination-item-link pager-edge"
        disabled={disabled}
        onClick={(event) => {
            event.stopPropagation();
            onClick();
        }}
        onKeyDown={(event) => event.stopPropagation()}
    >
        {children}
    </button>
);

export const createPagerItemRender =
    (
        current: number,
        lastPage: number,
        goTo: (page: number) => void,
    ): PagerItemRender =>
    (_page, type, element) => {
        if (type === 'prev') {
            return (
                <span className="pager-edge-group">
                    <EdgeButton disabled={current <= 1} onClick={() => goTo(1)}>
                        <DoubleLeftOutlined />
                    </EdgeButton>
                    {element}
                </span>
            );
        }
        if (type === 'next') {
            return (
                <span className="pager-edge-group">
                    {element}
                    <EdgeButton
                        disabled={current >= lastPage}
                        onClick={() => goTo(lastPage)}
                    >
                        <DoubleRightOutlined />
                    </EdgeButton>
                </span>
            );
        }
        return element;
    };
